import { type PropsWithChildren } from 'react';

import { AnnotationsAxisConfigContext } from '../components/axis/contexts/AnnotationsAxisConfig.context.js';
import { AnnotationsChartConfigContext } from '../contexts/AnnotationsChartConfig.context.js';
import { AnnotationsChartConfigProperties } from '../types/annotations-chart-config-props.js';

export const AnnotationsChartConfigProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: AnnotationsChartConfigProperties }>) => {
  const { xAxisConfig } = config;

  return (
    <AnnotationsChartConfigContext.Provider value={config}>
      <AnnotationsAxisConfigContext.Provider value={xAxisConfig}>
        {children}
      </AnnotationsAxisConfigContext.Provider>
    </AnnotationsChartConfigContext.Provider>
  );
};
